import _pathOr from "ramda/src/pathOr";
import _identity from "ramda/src/identity";
import _propOr from "ramda/src/propOr";
import _path from "ramda/src/path";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toUpper from "ramda/src/toUpper";
export var gqlReqToHttpReq = function gqlReqToHttpReq(opts) {
  var _ref;
  var method = _toUpper(opts.method || 'POST');
  return _ref = {
    method: method
  }, _defineProperty(_ref, {
    POST: 'body',
    GET: 'query'
  }[method], {
    query: opts.query,
    variables: {
      POST: opts.variables,
      GET: JSON.stringify(opts.variables)
    }[method],
    operationName: opts.operationName
  }), _defineProperty(_ref, "pathname", opts.path || opts.pathname), _defineProperty(_ref, "headers", opts.headers), _defineProperty(_ref, "context", opts.context), _ref;
};
export var getFirstError = function getFirstError(res) {
  var firstError = _path(['errors', 0], res);
  if (!firstError) return null;
  var serviceName = _path(['extensions', 'serviceName'], firstError);
  var queryPath = _propOr([], 'path', firstError).join('.');
  var prefix = [serviceName, queryPath].filter(_identity).join('.');
  var stack = _pathOr([], ['extensions', 'exception', 'stacktrace'], firstError).join('\n');
  return Object.assign(Error(firstError.message), {
    stack: prefix ? "[".concat(prefix, "] ").concat(stack) : stack,
    code: _pathOr('INTERNAL_SERVER_ERROR', ['extensions', 'code'], firstError),
    queryPath: queryPath,
    serviceName: serviceName
  });
};
export var throwFirstError = function throwFirstError(res) {
  var firstError = getFirstError(res);
  if (firstError) throw firstError;
};